import { render, staticRenderFns } from "./PassengerInformation.vue?vue&type=template&id=5969679a&scoped=true&"
import script from "./PassengerInformation.vue?vue&type=script&lang=js&"
export * from "./PassengerInformation.vue?vue&type=script&lang=js&"
import style0 from "./PassengerInformation.vue?vue&type=style&index=0&id=5969679a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969679a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5969679a')) {
      api.createRecord('5969679a', component.options)
    } else {
      api.reload('5969679a', component.options)
    }
    module.hot.accept("./PassengerInformation.vue?vue&type=template&id=5969679a&scoped=true&", function () {
      api.rerender('5969679a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/booking/PassengerInformation.vue"
export default component.exports